module.exports = __webpack_public_path__ + "img/aq2@2x.e9294977.png";